import { jsx as _jsx } from "react/jsx-runtime";
import { logoConfig } from './logo-config';
/**
 * A component to render Awaze brands logos as `<svg>`.
 *
 * Extra props can be passed in and they will be directly attached to the `<svg>` element.
 */
export function Logo({ brand, variant, ...rest }) {
    const Logo = logoConfig[brand][variant]
        ? logoConfig[brand][variant]
        : logoConfig[brand].default;
    return Logo ? _jsx(Logo, { ...rest }) : null;
}
//# sourceMappingURL=logo.js.map